var _g, _g2, _g3, _g4, _g5, _g6, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveDeepBreathing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 150,
    viewBox: "0 0 278 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.137 120.862C139.944 119.129 154.596 101.668 152.863 81.8612C151.13 62.0546 133.669 47.403 113.862 49.1358C94.0554 50.8687 79.4038 68.3299 81.1366 88.1364C82.8695 107.943 100.331 122.595 120.137 120.862Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.948 71.6189V71.6189C127.214 74.6661 124.96 77.3525 121.913 77.619V77.619C118.866 77.8856 116.179 75.6315 115.913 72.5844L115.43 67.067",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.879 73.5496V73.5496C105.146 76.5968 107.832 78.8509 110.879 78.5843V78.5843C113.926 78.3177 116.181 75.6314 115.914 72.5842L115.431 67.0668",
    stroke: "white",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4736 93.1342C95.1417 89.341 96.2403 70.1337 107.617 69.1384C112.443 68.7162 113.197 81.3042 113.667 86.6778C114.451 95.6436 112.81 100.652 101.084 101.678C96.9477 102.04 95.8055 96.9274 95.4736 93.1342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.611 89.2729C139.279 85.4797 134.862 66.755 123.486 67.7502C118.66 68.1725 120.103 80.7002 120.573 86.0738C121.358 95.0396 123.844 99.6868 135.569 98.6609C139.706 98.299 139.943 93.0661 139.611 89.2729Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.995 125.607C188.45 128.371 204.842 116.462 207.607 99.0065C210.371 81.551 198.462 65.1593 181.006 62.3946C163.551 59.6299 147.159 71.5392 144.394 88.9947C141.63 106.45 153.539 122.842 170.995 125.607Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.457 84.5998V84.5998C187.032 87.2852 184.51 89.1174 181.825 88.6921V88.6921C179.139 88.2668 177.307 85.745 177.732 83.0595L178.503 78.197",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.009 81.5197V81.5197C167.584 84.2052 169.416 86.727 172.101 87.1523V87.1523C174.787 87.5776 177.309 85.7454 177.734 83.06L178.504 78.1975",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.685 96.3887C156.215 93.0458 161.293 76.716 171.319 78.304C175.572 78.9776 173.515 89.9968 172.765 94.7325C171.514 102.634 169.021 106.601 158.687 104.964C155.042 104.386 155.156 99.7317 155.685 96.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.583 102.55C195.112 99.2069 195.329 82.1072 185.303 80.5193C181.05 79.8456 179.601 90.961 178.851 95.6967C177.599 103.598 178.744 108.141 189.078 109.778C192.724 110.355 194.053 105.893 194.583 102.55Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.91 74.891C212.896 76.0456 222.737 68.0763 223.891 57.0911C225.046 46.1059 217.077 36.2647 206.092 35.1101C195.106 33.9555 185.265 41.9248 184.111 52.91C182.956 63.8952 190.925 73.7364 201.91 74.891Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.844 48.7583V48.7583C210.667 50.4483 209.153 51.6744 207.463 51.4968V51.4968C205.773 51.3191 204.547 49.8051 204.724 48.1151L205.046 45.055",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.605 47.4722V47.4722C198.428 49.1622 199.654 50.6762 201.344 50.8539V50.8539C203.034 51.0315 204.548 49.8055 204.725 48.1154L205.047 45.0554",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4 57.155C191.621 55.0512 194.256 44.693 200.566 45.3562C203.243 45.6375 202.319 52.5823 202.006 55.5626C201.483 60.5352 200.057 63.0925 193.554 62.409C191.26 62.1678 191.179 59.2588 191.4 57.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.879 59.7282C216.1 57.6244 215.676 46.9447 209.367 46.2815C206.69 46.0002 206.149 52.9852 205.836 55.9655C205.313 60.9381 206.177 63.736 212.68 64.4195C214.974 64.6607 215.658 61.832 215.879 59.7282Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.346 67.824C178.922 65.9767 191.673 50.2307 189.825 32.6544C187.978 15.0781 172.232 2.32728 154.656 4.17462C137.079 6.02196 124.329 21.7679 126.176 39.3442C128.023 56.9205 143.769 69.6714 161.346 67.824Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.635 23.9537V23.9537C166.919 26.6578 164.957 29.0802 162.253 29.3644V29.3644C159.549 29.6486 157.127 27.687 156.843 24.9829L156.328 20.0868",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.052 26.0123V26.0123C147.336 28.7164 149.758 30.678 152.462 30.3938V30.3938C155.166 30.1096 157.128 27.6872 156.844 24.9831L156.329 20.087",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.997 43.5627C138.643 40.1966 139.321 23.109 149.417 22.0479C153.7 21.5978 154.565 32.7738 155.066 37.5423C155.902 45.4985 154.521 49.975 144.116 51.0687C140.445 51.4545 139.351 46.9287 138.997 43.5627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.162 39.4464C177.808 36.0804 173.592 19.5072 163.496 20.5683C159.214 21.0184 160.691 32.1301 161.192 36.8986C162.028 44.8548 164.31 48.9464 174.715 47.8528C178.386 47.4669 178.516 42.8125 178.162 39.4464Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.326 53.94C116.548 54.8647 128.017 44.8952 128.941 31.6727C129.866 18.4501 119.897 6.98158 106.674 6.05697C93.4514 5.13236 81.9829 15.1018 81.0583 28.3244C80.1337 41.5469 90.1031 53.0154 103.326 53.94Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.946 22.2263V22.2263C112.803 24.2605 111.039 25.7943 109.005 25.652V25.652C106.97 25.5098 105.437 23.7454 105.579 21.7112L105.836 18.0278",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2131 21.196V21.196C98.0709 23.2302 99.6047 24.9946 101.639 25.1369V25.1369C103.673 25.2791 105.438 23.7454 105.58 21.7111L105.837 18.0278",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9786 33.1107C90.1556 30.5784 92.8821 18.0457 100.477 18.5768C103.699 18.8021 102.882 27.1694 102.632 30.7568C102.213 36.7422 100.61 39.8687 92.782 39.3213C90.0204 39.1282 89.8015 35.6429 89.9786 33.1107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.442 35.1702C119.62 32.638 118.664 19.8478 111.069 19.3168C107.847 19.0914 107.491 27.491 107.24 31.0783C106.822 37.0637 107.974 40.3829 115.802 40.9303C118.563 41.1234 119.265 37.7025 119.442 35.1702Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10819_8346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0465 74.9717C85.0771 74.3936 93.5505 64.983 92.9724 53.9524C92.3943 42.9218 82.9836 34.4484 71.9531 35.0265C60.9225 35.6046 52.4491 45.0153 53.0272 56.0458C53.6053 67.0764 63.0159 75.5498 74.0465 74.9717Z",
    fill: "#FA4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7821 47.7631V47.7631C78.8711 49.4601 77.5675 50.9079 75.8705 50.9969V50.9969C74.1734 51.0858 72.7257 49.7822 72.6367 48.0852L72.4757 45.0125",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4931 48.4077V48.4077C66.582 50.1047 68.0298 51.4083 69.7268 51.3193V51.3193C71.4238 51.2304 72.7274 49.7826 72.6385 48.0856L72.4774 45.0129",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8918 59.0987C60.7811 56.9863 61.7634 46.3433 68.099 46.0113C70.7869 45.8704 70.9614 52.8742 71.1183 55.8668C71.38 60.8599 70.3716 63.6088 63.8413 63.951C61.5376 64.0718 61.0025 61.2112 60.8918 59.0987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4699 57.8107C85.3592 55.6982 83.2698 45.2162 76.9342 45.5483C74.2463 45.6891 74.8048 52.6727 74.9616 55.6654C75.2233 60.6585 76.5135 63.2869 83.0438 62.9447C85.3475 62.8239 85.5806 59.9231 85.4699 57.8107Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 92C64 90.8954 64.8954 90 66 90H86.2654C87.2607 90 88.1046 90.7319 88.2453 91.7172L91.7547 116.283C91.8954 117.268 92.7393 118 93.7346 118H194.265C195.261 118 196.105 117.268 196.245 116.283L199.755 91.7172C199.895 90.7319 200.739 90 201.735 90H222C223.105 90 224 90.8954 224 92V118V144C224 145.105 223.105 146 222 146H192H96H66C64.8954 146 64 145.105 64 144V118V92Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 58.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 56.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 36 150)",
    fill: "#24284E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227 32L242.5 28.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231 75L247 78",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23L41.5 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85.5L46.5 82",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.999,
    y: 52.2734,
    width: 72,
    height: 72,
    rx: 36,
    transform: "rotate(-5 77.999 52.2734)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.4,
    y: 57.3887,
    width: 64,
    height: 64,
    rx: 32,
    transform: "rotate(9 149.4 57.3887)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.201,
    y: 33.0195,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(6 186.201 33.0195)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.831,
    y: 7.51953,
    width: 64,
    height: 64,
    rx: 32,
    transform: "rotate(-6 122.831 7.51953)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.7324,
    y: 4.38281,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(4 82.7324 4.38281)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10819_8346"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.9805,
    y: 36.0732,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-3 51.9805 36.0732)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveDeepBreathing);
export default __webpack_public_path__ + "static/media/collective-deep-breathing.f5563ace36fe6508375d4521309cb6dd.svg";
export { ForwardRef as ReactComponent };